import React from 'react';
import Carousel from 'nuka-carousel';
import background from '../SearchPage/Slider/background.module.css';
import {SliderDiv} from '../SearchPage/Slider/FilterBanner';

import img8 from '../../images/icons/arrowLeft.png';
import img9 from '../../images/icons/arrowRight.png';

const SliderCard = (props) => {
  const styles = {
    buttonStyle : {
      paddingLeft: "0.8rem",
      paddingRight: "0.8rem",
      paddingTop: "1.1rem",
      paddingBottom: "0.8rem",
      borderStyle:"none",
      background:"#fff",
      borderRadius: "14px",
    },
    buttonStyle2 : {
      paddingLeft: "0.8rem",
      paddingRight: "0.8rem",
      paddingTop: "0.9rem",
      paddingBottom: "0.8rem",
      borderStyle:"none",
      background:"#fff",
      borderRadius: "14px",
    },
  };
  const imgURL = props.imgURL;
  const imgURL1 = props.imgURL1;
  const imgURL2 = props.imgURL2;
  const imgURL3 = props.imgURL3;
  const imgURL4 = props.imgURL4;
  const imgURL5 = props.imgURL5;
  const imgURL6 = props.imgURL6;
  const imgURL7 = props.imgURL7;
  const imgURL8 = props.imgURL8;
  const imgURL9 = props.imgURL9;
  const imgURL10 = props.imgURL10;
  const videoURL = props.videoURL;
  return (
    <SliderDiv >
    <Carousel autoplay={false} wrapAround={true}
      renderCenterLeftControls={({ previousSlide }) => (
        <button style={styles.buttonStyle} onClick={previousSlide}>
          <img 
            src={img8} 
          title='LFC' alt='LFC'/>
        </button>
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <button style={styles.buttonStyle2} onClick={nextSlide}>
          <img src={img9} title='LFC' alt='LFC' />
        </button>
      )}
    >
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL && typeof(imgURL) === 'string' ? imgURL : '' } />

      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL1 && typeof(imgURL1) === 'string' ? imgURL1 : ''} />

      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL2 && typeof(imgURL2) === 'string' ? imgURL2 : ''} />
      
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front'
        src={!!imgURL3 && typeof(imgURL3) === 'string' ? imgURL3 : ''} />
      
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL4 && typeof(imgURL4) === 'string' ? imgURL4 : ''} />
      
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL5 && typeof(imgURL5) === 'string' ? imgURL5 : ''} />
      
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL6 && typeof(imgURL6) === 'string' ? imgURL6 : ''} />
      
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL7 && typeof(imgURL7) === 'string' ? imgURL7 : ''} />
      
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL8 && typeof(imgURL8) === 'string' ? imgURL8 : ''} />
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL9 && typeof(imgURL9) === 'string' ? imgURL9 : ''} />
      <img className={`${background.background} sliderImgblog sliderImgblog1`} 
        alt='LFC' title='Life Care Front' 
        src={!!imgURL10 && typeof(imgURL10) === 'string' ? imgURL10 : ''} />
      <video 
        width="300" height="400" controls poster={!!imgURL1 && typeof(imgURL1) === 'string' ? imgURL1 : ''}>
        <source src={videoURL} type="video/mp4"></source>
        <source src="" type="video/ogg"></source>       
      </video>
    </Carousel>
  </SliderDiv>
  )
};

export default SliderCard;